import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'styles/swiper.css'

// import required modules
import useWindowSize from 'hooks/windowSize';
import FullNameSVG from 'components/handwrites/fullName';
import AnimatedBox from 'components/animations/animatedBox';
import { AboutMeContentMobileOne, AboutMeContentMobileTwo } from 'components/contents/about';
import BackToHome from 'components/backToHome';
import { NextButton } from './achieved';

export default function AboutMobile() {
  const {size: {height}} = useWindowSize();
  const [activeIndex, setActiveIndex] = useState(0);

  return (
      <div className='swiper-background'>
        <BackToHome/>
        <SwiperSlide>
        <AnimatedBox className='swiper-back'>
          <span className='swiper-back-source'>
            Contact: jj.ancuta@gmail.com
          </span>
        </AnimatedBox>

          <Swiper
            mousewheel={true}
            className="mySwiper2 swiper-v"
            direction={'vertical'}
            slidesPerView="auto"
            speed={500}
            spaceBetween={height/2.5}
            onSlideChange={(swiper: any) => {setActiveIndex(swiper.activeIndex)}}
          >
            <NextButton hide={(activeIndex == 0 || activeIndex == 2)}/>
            <SwiperSlide style={{height: "30vh"}} className='first-slide'>
                {/* transform: `translateX(calc(-50% - (${progress} / 0.01) * 50%))`, */}
              <AnimatedBox className='svg1'>
                    <FullNameSVG/>
              </AnimatedBox>
            </SwiperSlide>
            <SwiperSlide style={{height: 'auto', overflowY: 'scroll', paddingTop: "3em"}} >
              <AboutMeContentMobileOne/>
            </SwiperSlide>

            <SwiperSlide style={{height: 'auto', overflowY: 'scroll', paddingTop: "3em"}} >
              <AboutMeContentMobileTwo/>
            </SwiperSlide>
          </Swiper>
        </SwiperSlide>
      <style>{`
        .swiper-back{
          background: url('/sunset.jpg') no-repeat center center;
          background-size: contain;
          background-origin: content-box;
        }
      `}</style>
      </div>
  );
}